import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {IFormInput} from '@appNeo/neoShared/helpers/interfaces/IForm-input';

import {FormularioService} from '@appNeo/neoShared/services/formulario/formulario.service';
import {FormularioComponent} from '@appNeo/neoShared/components/formulario/formulario.component';
import {NotificacionComponent} from '@appNeo/neoShared/components/notificacion/notificacion.component';
import {NotificacionEnum} from '@appNeo/neoShared/helpers/enums/Notificacion.enum';
import {IconEnum} from '@appNeo/neoShared/helpers/enums/Icon.enum';
import { FORMINPUTCONTACTOLEFT, FORMINPUTCONTACTORIGHT } from '@appNeo/pages/pages/pagina-contacto/contacto-configuracion';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { EmailContactoService } from '@appNeo/neoShared/services/email-contacto/email-contacto.service';
import { AccionDialogEnum } from '@appNeo/neoShared/helpers/enums/AccionDialog.enum';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { ActivatedRoute } from '@angular/router';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'neo-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [FormularioService],
})
export class ContactoComponent implements OnInit {
  @ViewChild('notificacion') notificacion: NotificacionComponent;
  @ViewChild('formularioContactoLeft') formularioContactoLeft: FormularioComponent;
  @ViewChild('formularioContactoRight') formularioContactoRight: FormularioComponent;

  @Input() tituloPrincipal = '¿Cómo podemos ayudarte?';
  @Input() tituloDireccion = 'Dónde estamos';
  @Input() formInputContactoLeft: IFormInput[] = FORMINPUTCONTACTOLEFT;
  @Input() formInputContactoRight: IFormInput[] = FORMINPUTCONTACTORIGHT;

  direccion;
  linkDireccion;
  infoTit;
  infoTxt;
  telefono1;
  telefono2;
  email1;
  email2;
  precargaMeta;
  clave_matrix_mapaApikeyServidor;
  constructor(
    private formularioService: FormularioService,
    private preferenciasService: PreferenciasService,
    public auxiliarService: AuxiliarService,
    private emailContactoService: EmailContactoService,
    private edicionSeccionesService: EdicionSeccionesService,
    private helpersService: HelpersService,
    private route: ActivatedRoute,
    private confTitulo: ConfigTituloPaginasService
  ) {
    this.route.data.subscribe(
      response => {
        console.log('Data precargada', response);
        this.clave_matrix_mapaApikeyServidor = response.seccionesEditables.clave_matrix_mapaApikeyServidor?.valor;
        this.precargaMeta = response.seccionesEditables.precargaMeta;
      }
    );
  }

  ngOnInit(): void {
   this.iniciarPagina();
  }

  iniciarPagina() {
    if (this.helpersService.hayModulo('edicion')) {
      // **********************************
      // Titulo y meta
      // **********************************
      this.confTitulo.establecerTitulo('Contacto', 'contacto-meta', this.precargaMeta, 'meta-tit');
      this.confTitulo.establecerMeta(environment.descripcionMetaDefecto, 'contacto-meta', this.precargaMeta, 'meta-des');
      this.edicionSeccionesService.getContenidoBloquesSubseccion('contacto-txt').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;     
          this.tituloPrincipal = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'txt-tit', indice);     
        })
      });
      this.edicionSeccionesService.getContenidoBloquesSubseccion('contacto-hq').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;     
          this.tituloDireccion = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-dir-tit', indice);        
          this.direccion = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-dir-txt', indice);        
          this.linkDireccion = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-dir-lnk', indice);        
          this.infoTit = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-info-tit', indice);        
          this.infoTxt = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-info-txt', indice);        
          this.telefono1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-tel1', indice);             
          this.telefono2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-tel2', indice);        
          this.email1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-mail1', indice);        
          this.email2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hq-mail2', indice);        
        })
      })
    } else {
      this.direccion = this.preferenciasService.get('contacto_direccionMostrar');
      this.telefono1 = this.preferenciasService.get('contacto_telefono');
      this.email1 = this.preferenciasService.get('contacto_email');
    }
  }

  enviarContacto() {
    if (this.notificacion) this.notificacion.eliminarNotificaciones();
    this.formularioContactoLeft.formValueReset = true;
    this.formularioContactoRight.formValueReset = true;
    const eventoFormularioLeft = this.formularioContactoLeft.validaCampos(false);
    const eventoFormularioRight = this.formularioContactoRight.validaCampos(false);
    if (this.formularioContactoLeft.esFormularioValido() && this.formularioContactoRight.esFormularioValido()) {
      let peticion = { ...eventoFormularioLeft.valores, ...eventoFormularioRight.valores };
      delete peticion?.politica_privacidad;
      delete peticion?.captcha;
      if (!peticion?.comunicacionesComerciales) {
        peticion['comunicacionesComerciales'] = false;
      }
      this.emailContactoService.enviar(peticion).subscribe(
        x => {
          this.showResult('Solicitud de contacto enviada con éxito', 'ok')
        },
        e => {
          let aviso = (typeof e?.mensaje === 'string') ? e.mensaje : '';
          this.showResult('Se ha producido un error al enviar la solicitud ' + aviso, 'ko')
        }
      );
    }
  }

  showResult(message: string, status: string) {
    if (this.notificacion) this.notificacion.eliminarNotificaciones();
    if (status === 'ok') {
      if (this.notificacion) this.notificacion.crearNotificacion(NotificacionEnum.Exito, '', message, false, IconEnum.Exito, '', true);
      this.formularioContactoLeft.reset();
      this.formularioContactoRight.reset();
    } else {
      if (this.notificacion) this.notificacion.crearNotificacion(NotificacionEnum.Error, '', message, true, IconEnum.Error);      
    }
    // grabando = false;
    // cargando = false;
  }

}
